import { IconCircleError } from '@iwoca/icons';
import { t } from '@lingui/macro';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import styles from './ConditionalOfferNotice.module.css';

type TProps = {
  hasMultipleOffers: boolean;
  vatMonthsRequired?: number;
};

export const ConditionalOfferNotice = ({
  hasMultipleOffers,
  vatMonthsRequired,
}: TProps) => {
  const { introducerType } = useIntroducerContext();

  const introducerEmail =
    introducerType === 'accountant'
      ? t`accountants@iwoca.co.uk`
      : t`brokers@iwoca.co.uk`;

  const label = hasMultipleOffers ? 'These offers are' : 'This offer is';

  const vatReturnMessaging = vatMonthsRequired
    ? `most recent ${vatMonthsRequired} months VAT return`
    : 'most recent VAT return';

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <IconCircleError className={styles.icon} height={24} width={24} />
      </div>
      <p className={styles.text}>
        {label} subject to providing your client’s {vatReturnMessaging} and may
        be revoked based on this information. Email your client’s VAT returns to{' '}
        <a href={`mailto:${introducerEmail}`}>{introducerEmail}</a> before
        accepting this offer.
      </p>
    </div>
  );
};
